import { getNetwork } from '../common/Utils';

/**
 * 네트워크별 assets 도메인.
 * md-cookieLayer/util/util.ts 의 getWstaticUrlObjectStorage() 와 동일한 매핑이다.
 */
const ASSETS_DOMAIN: { [key: string]: string } = {
  sb: 'https://sb-assets.plaync.com',
  rc: 'https://rc-assets.playnccdn.com',
  live: 'https://assets.playnccdn.com',
};

export const getAssetsDomain = (): string => ASSETS_DOMAIN[getNetwork()] || ASSETS_DOMAIN.live;

/** <link rel="stylesheet"> 를 head에 추가한다. 이미 있으면 아무것도 하지 않는다. */
export const loadCss = (href: string): void => {
  if (document.querySelector(`link[href="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;

  document.head.appendChild(link);
};

/** <script> 를 head에 추가하고 로드 완료를 기다린다. */
export const loadJs = (src: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const exist = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
    if (exist) {
      if (exist.dataset.loaded === 'true') {
        resolve();
        return;
      }
      exist.addEventListener('load', () => resolve());
      exist.addEventListener('error', () => reject(new Error(`[ncui.newsletter] 스크립트 로드 실패: ${src}`)));
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    });
    script.addEventListener('error', () => reject(new Error(`[ncui.newsletter] 스크립트 로드 실패: ${src}`)));

    document.head.appendChild(script);
  });
